import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { ThemeProviderContext, } from "./theme-context.js";
const DARK_SCHEME = "(prefers-color-scheme: dark)";
const systemTheme = () => window.matchMedia(DARK_SCHEME).matches ? "dark" : "light";
export function ThemeProvider({ children, defaultTheme = "system", storageKey = "ui-theme", ...props }) {
    const [theme, setTheme] = useState(() => localStorage.getItem(storageKey) || defaultTheme);
    const [system, setSystem] = useState(systemTheme);
    // While the OS decides, follow it when it changes, so switching the system
    // appearance repaints an open tab rather than waiting for a reload.
    useEffect(() => {
        if (theme !== "system")
            return;
        const query = window.matchMedia(DARK_SCHEME);
        const onChange = () => setSystem(query.matches ? "dark" : "light");
        onChange();
        query.addEventListener("change", onChange);
        return () => query.removeEventListener("change", onChange);
    }, [theme]);
    const resolvedTheme = theme === "system" ? system : theme;
    useEffect(() => {
        const root = window.document.documentElement;
        root.classList.remove("light", "dark");
        root.classList.add(resolvedTheme);
    }, [resolvedTheme]);
    const value = {
        theme,
        resolvedTheme,
        setTheme: (theme) => {
            localStorage.setItem(storageKey, theme);
            setTheme(theme);
        },
    };
    return (_jsx(ThemeProviderContext.Provider, { ...props, value: value, children: children }));
}
//# sourceMappingURL=theme-provider.js.map